import { useMemo } from 'react';
import createCache from '@emotion/cache';
import { CacheProvider } from '@emotion/react';
import CssBaseline from '@mui/material/CssBaseline';
import { ThemeProvider as MuiThemeProvider } from '@mui/material/styles';

import { useSettingsContext } from 'src/components/settings';

import { createTheme } from './create-theme';
import { RTL } from './with-settings/right-to-left';

const emotionCache = createCache({
  key: 'css',
  prepend: true,
  insertionPoint:
    typeof document !== 'undefined'
      ? document.querySelector('meta[name="emotion-insertion-point"]')
      : undefined,
});

export function ThemeProvider({ children }) {
  const settings = useSettingsContext();

  const theme = useMemo(() => {
    try {
      return createTheme('en', settings);
    } catch (error) {
      console.warn('Theme creation error:', error);
      return createTheme('en', {});
    }
  }, [settings]);

  return (
    <CacheProvider value={emotionCache}>
      <MuiThemeProvider theme={theme}>
        <CssBaseline enableColorScheme />
        <RTL direction={settings.direction}>{children}</RTL>
      </MuiThemeProvider>
    </CacheProvider>
  );
}
